/* eslint-disable no-shadow */
export enum CompanyRole {
	ADMIN = 'ADMIN',
	CLIENT = 'CLIENT',
}
